import React from 'react';
import Image from 'next/image';
import MenuSidebar from '@/app/components/menuSidebar';

const Fence: React.FC = () => {
    const fixedChecked = true;

    return (
        <div className='wrapper max-w-10xl bg-white'>
            <div className='
                max-w-7xl mx-auto p-6 bg-white shadow-md rounded-lg
                2xl:max-w-2xl
                lg:max-w-lg 
                md:max-w-md 
                sm:max-w-sm
                flex flex-col lg:flex-row gap-6
                '>
                <div className='flex-1'>
                    <h1 className="text-3xl font-bold mb-4">구성도</h1>
                    <div className="mb-6 text-gray-700">
                        울타리/침입 감시시스템은 지능형 영상인식기술을 기반으로 영상정보를 분석하여 자동으로 침입상황(배회, 침입, 월담 등)을 탐지하고,
                        경보하여 육안으로 침입상황을 확인할 수 있으며, 울타리외곽 설비를 통하여 외곽(경계)의 기어오름이나 절단 등의 침입요소를 감지하여
                        침입의 발견 및 위치를 알아낼 수 있는 시스템으로 침입 시 침입지점을 정확히 찾아주는 시스템입니다.
                    </div>

                    <div className="mb-6">
                        <Image
                            src="/contents/image/fenceDiagram.png"
                            className="w-full h-auto object-cover rounded-lg shadow-md"
                            alt="Fence Diagram"
                            width={1200}
                            height={800}
                        />
                    </div>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">주요 기술 및 특징</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '호환 / 연계: 표준 프로토콜을 준수 및 SDK 제공으로 기존 및 신설 기관 / 시스템과 호환',
                            '맞춤 서비스: 보유중인 센서, 네트워크, 영상인식 S/W 및 H/W 솔루션과 결합하여 설치목적과 요구에 맞는 통합관제 서비스 제공',
                            '웹브라우저 모니터링: 별도의 전용프로그램 없이 웹브라우저를 통해 네트워크가 연결된 장소 어디에서나 이용 가능',
                            '손실 없는 전송: H.264 / MPEG4 디지털 압축 영상을 인터넷을 통해 손실 없이 전송하여 다중 사용자 접속 시에도 원활한 감시 가능',
                            '실시간 듀얼 스트리밍: 영상 압축 모드 및 초당 프레임(최대 30)을 설정하여, PC와 모바일 등 용도에 맞게 듀얼 스트리밍 가능',
                            '이중화: 센서와 영상처리기술을 기반으로 한 침입감지 알고리즘을 통한 이중화 작업을 통하여 더욱 정확한 상황 검지 실현'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                <span>{text}</span>
                            </li>
                        ))}
                    </ul>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">기능</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '통보기능: 상황발생 즉시 사건을 인지하고 오디오/팝업창 등을 통하여 관리자에게 알려줌',
                            '지능형 영상인식기술을 통한 침입감지: 특정영역 내 불법 진입시도 움직임, 담장을 통한 불법침입(월담), 지정된 시간 후에도 같은 위치에 남아서 배회하는 등 이상행위를 검출',
                            '개체추적 기능: 영상처리기술을 통하여 감지된 개체를 추적하여 화면에 디스플레이 함',
                            '영상저장 기능: 고화질 영상 녹화를 활용한 범행 단서 및 증거 확보',
                            '타 장비 연동기능: 경보에 따른 타 장비(카메라, 투광등, 경광등)와 연동',
                            '검색/조회 기능: 다양한 객체와 특징(사람, 복장, 색상, 움직임, 여부 등)을 바탕으로 저장된 영상에서 원하는 정보만 신속하게 검색이 가능',
                            '설정기능: 감시구간, 감시 폭, 반응속도, 현장 지형도 등을 손쉽게 작성/변경'
                        ].map((text, index) => (
                            <li key={index + 7} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                <span>{text}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='h-auto p-30px'>
                    <MenuSidebar category="UTM"/>
                </div>
            </div>
        </div>
    );
};

export default Fence;
